
<template>
  <v-container class="ma-0">
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Προσφορές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="quotes"
      :search="search"
      :loading="loading"
      loading-text="Loading... Please wait"
      item-key="quote_id"
      class="elevation-1"
      show-select
      sort-by="quote_id"
      sort-desc
      @item-selected="itemSelected"
      @toggle-select-all="itemSelectAll"
    >
    <template v-slot:body.append="{ items }">
      <tr>
        <td v-for="(header, i) in headers" :key="i">
          <div class="text-right" v-if="header.value === 'net_value'">
            {{ $tocurr(calculateTotal('net_value', items)) }}
          </div>
          <div class="text-right" v-else-if="header.value === 'total_value'">
            {{ $tocurr(calculateTotal('total_value', items)) }}
          </div>
          <div class="text-right" v-else-if="header.value === 'vat_value'">
            {{ $tocurr(calculateTotal('vat_value', items)) }}
          </div>
          <div v-else>
            <!-- empty table cells for columns that don't need a sum -->
          </div>
        </td>
      </tr>
    </template>
    <template v-slot:top>
      <v-toolbar
        flat
      >
      <v-row>
            <v-col cols="6" sm="4">
              <v-select
                v-model="vehicle"
                :items="uniqvehicles"
                prepend-icon="mdi-truck"
                label="Όχημα"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(vehicle, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            </v-row>
        <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              :to="{name: 'quote-create', query: {cid: customer.Cid}} "
            >
              Νεα Προσφορα
            </v-btn>
      </v-toolbar>
    </template>
     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="'/quote/edit/'+item.sha"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-btn
          icon
          :href="'http://localhost:8999/quotes/pdf/'+item.quoteid"
          target="_blank"
        >
         <v-icon>mdi-file-pdf-box</v-icon>
        </v-btn>
        <v-btn
          icon
          :href="'http://localhost:8999/quotes/word/'+item.quoteid"
          target="_blank"
        >
         <v-icon>mdi-file-word</v-icon>
        </v-btn>
     </template>

     <template v-slot:item.net_value="{ item }">
       {{ $tocurr(item.net_value) }}
    </template>
    <template v-slot:item.total_value="{ item }">
       {{ $tocurr(item.total_value) }}
    </template>
    <template v-slot:item.vat_value="{ item }">
       {{ $tocurr(item.vat_value) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.quoteid }}
      </td>
    </template>



    </v-data-table>
  </v-card>
    </v-container>
</template>


<script>

import { uniqBy } from "lodash";
//import QuoteCard from '../../components/QuoteCard.vue';

export default {
  data() {
    return {
      expanded: [],
      dialog: false,
      loading: true,
      balance: 0.0,
      info: {
      name: '',
      address: '',
      telephone:'',
      nino: '',
      doi: '',
      city: ''
      },
      toExport: [],
      cid: null,
      search: '',
      customer_id: this.$route.params.gid,
      customer: {},
      vehicle: [],
      quotes: [],
      headers: [
          {
            text: 'Προσφορά',
            align: 'start',
            //sortable: false,
            value: 'quote_id',
            width: '10%',
          },
          { text: 'Ημερομηνία', value: 'qdate', width: '10%'},
          { text: 'Οχημα', value: 'vehicle',
          filter: (value) => {
            if (this.vehicle.length == 0) return true;
            return this.vehicle.includes(value);
            },
          },
          { text: 'Έκδοση', value: 'version', align: 'end', groupable: false },
          { text: 'Καθαρή αξία', value: 'net_value', align: 'end', groupable: false },
          { text: 'ΦΠΑ', value: 'vat_value', align: 'end' , groupable: false},
          { text: 'Συνολο', value: 'total_value', align: 'end', groupable: false },
          { text: 'Actions', value: 'actions', groupable: false },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const resp = await this.$api.get("/customers/id-to-cid/", {params: {customer_id: this.$route.params.id}});
        this.cid = resp.data;
        // console.log(response);
        console.log(this.cid)
        const response = await this.$api.get('/quotes/', {params: {customer_cid: this.cid}});
        this.quotes = response.data;
        //this.$store.customer.quotes = response.data;
        //this.quotes = this.$store.customer.quotes;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  computed: {
    uniqvehicles() {
      return uniqBy(this.quotes, 'vehicle').map(q => q.vehicle);
    }
  },

  methods: {
    itemSelected(selected) {
    if (selected.value) {
      this.toExport.push(selected.item);
    } else {
      const index = this.toExport.indexOf(selected.item);

        this.toExport.splice(index, 1);
    }
  },
  itemSelectAll(selected) {
    if (selected.value) {
      for (let item of selected.items) {
        this.toExport.push(item.Id);
      }
    } else {
      this.toExport = []
    }
  },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  calculateTotal(key) {
    if (this.toExport.length) {
      return this.toExport.reduce((acc, quote) => acc + quote[key], 0);
    }
      return this.quotes.reduce((acc, quote) => acc + quote[key], 0);
  },  
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  }
}
</script>
